import moment from "moment";

export function formatDateTimeString(datetime?: string) {
  if (!datetime) {
    return datetime;
  }

  return moment.utc(datetime).format();
}

export function minsToMs(mins?: number) {
  if (!mins) return 0;
  return secsToMs(mins * 60);
}

export function secsToMs(seconds?: number) {
  if (!seconds) return 0;
  return seconds * 1000;
}

export function secsToMins(seconds?: number) {
  if (!seconds) return 0;
  return seconds / 60;
}
